// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"e658671f","835":"6b757cbc"}[chunkId] + ".chunk.css";
};